export const searchParametersTechnician = {
    CARD_NUMBER: 'card_number',
    FIRST_NAME: 'first_name',
    LAST_NAME: 'last_name',
    MANAGERS: 'managers',
    MIFARE_CODE: 'mifare_code',
}

/** Search parameters used in the technician API. */
export const searchParametersTechnicianApi = {
    CARD_NUMBER: 'serial_number__icontains',
    FIRST_NAME: 'first_name__icontains',
    LAST_NAME: 'last_name__icontains',
    MANAGERS: 'client__id__in',
    MIFARE_CODE: 'card_id__icontains',
}
